/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import classNames from "clsx";

import Button from "react-bootstrap/Button";

import { useApi } from "@/hooks/useApi";

import { transformData } from "@/utils/transformData";
import { attendanceMap } from "@/utils/mappings/attendance";

import { useThemeClassNames } from "@/hooks/useThemeClassNames";

import { ModalAddProcedures } from "@/components/HospitalizationPermits/ReportCard/ModalAddProcedures";
import { ProceduresTable } from "@/components/ProceduresTable";
import { SkeletonWrapper } from "@/components/SkeletonWrapper";
import { FormPatient } from "./FormPatient";
import { FormInternment } from "./FormInternment";
import { ReportCardAndHistoricTabs } from "../ReportCardAndHistoricTabs";

export function ReportCard() {
	const { id } = useParams();
	const { api } = useApi();

	const { border, background } = useThemeClassNames();

	const [showModalAddProcedures, setShowModalAddProcedures] = useState(false);
	const handleCloseModalAddProcedures = () => setShowModalAddProcedures(false);

	const [isLoading, setIsLoading] = useState(true);

	const [attendance, setAttendance] = useState<Attendance>({} as Attendance);
	const [procedures, setProcedures] = useState<Procedure[]>([]);

	async function handleFetchAttendance() {
		try {
			const { data } = await api.get(`/hospitalization-permits/report-card/${id}`);

			const transformedAttendance = transformData<Attendance>(data, attendanceMap);

			setAttendance(transformedAttendance);
			setProcedures(transformedAttendance.activeHospitalizationPermit?.procedures);
			setIsLoading(false);
		} catch (error) {
			console.log(error);
		}
	}

	useEffect(() => {
		handleFetchAttendance();
	}, []);

	return (
		<>
			<ReportCardAndHistoricTabs />

			<div className="mt-6">
				<div className={classNames("rounded mb-8", border)}>
					<div
						className={classNames(
							"flex-responsive d-flex justify-content-between p-4",
							background
						)}
					>
						<h6 className="fs-6 fw-bold">Informações do Paciente</h6>
						<div className="d-flex gap-1 fs-7">
							<label className="fw-bold">Nº do Prontuário:</label>
							<span>12345678</span>
						</div>
					</div>

					<FormPatient attendance={attendance} setAttendance={setAttendance} />
				</div>

				<div className={classNames("rounded mb-8", border)}>
					<div className={classNames("p-4", background)}>
						<label className="fs-6 fw-bold">Informações do Internamento</label>
					</div>

					<FormInternment attendance={attendance} setAttendance={setAttendance} />
				</div>

				<div className={classNames("pb-6 rounded mb-6", border)}>
					<div className={classNames("p-4 mb-4", background)}>
						<h6 className="fs-6 fw-bold">Procedimentos Solicitados</h6>
					</div>

					<div className="px-8">
						<div className="d-flex justify-content-end mb-4">
							{isLoading ? (
								<SkeletonWrapper className="w-80px" height={30} />
							) : (
								<Button
									className="py-2 px-4 fs-7"
									onClick={() => setShowModalAddProcedures(true)}
								>
									Adicionar
								</Button>
							)}
						</div>

						<ProceduresTable
							isLoading={isLoading}
							permitId={attendance.activeHospitalizationPermit?.id}
							procedures={procedures}
							setProcedures={setProcedures}
							actionsColumn
						/>
					</div>
				</div>

				<ModalAddProcedures
					show={showModalAddProcedures}
					onHide={handleCloseModalAddProcedures}
					procedures={procedures}
					setProcedures={setProcedures}
					permitId={attendance.activeHospitalizationPermit?.id}
				/>
			</div>
		</>
	);
}
